import { render } from "./OverviewBadge.vue?vue&type=template&id=d6133d52&scoped=true"
import script from "./OverviewBadge.vue?vue&type=script&lang=js"
export * from "./OverviewBadge.vue?vue&type=script&lang=js"

import "./OverviewBadge.vue?vue&type=style&index=0&id=d6133d52&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6133d52"]])

export default __exports__